// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__w-Pt1","footer":"ModalError_footer__QR3Ns"};